export const PRICING_CARD_CLASS_NAME = 'relative mx-auto flex w-full min-w-0 max-w-xl flex-col items-center p-3 text-center transition-transform duration-200 ease-out motion-reduce:transform-none motion-reduce:transition-none sm:p-6 md:h-full xl:p-9';

export const PRICING_CARD_COMPACT_CLASS_NAME = 'relative mx-auto flex w-full min-w-0 max-w-xl flex-col items-center p-4 text-center transition-transform duration-200 ease-out motion-reduce:transform-none motion-reduce:transition-none sm:p-5';

export const PRICING_CARD_TITLE_CLASS_NAME = 'text-2xl font-bold text-slate-50 sm:text-3xl';

export const PRICING_CARD_HEADER_CLASS_NAME = 'flex w-full flex-col items-center';

export const PRICING_CARD_PRICE_CLASS_NAME = 'mt-3 flex w-full flex-col items-center';
